export const COLUMNS = [
  {
    Header: "Customer",
    accessor: "name"
  },
  {
    Header: "Email",
    accessor: "email"
  }
];

export const REF_COLUMNS = [
  {
    Header: "Name",
    accessor: "fullName"
  },
  {
    Header: "Referral Code",
    accessor: "referralCode"
  }
];
